import React, {PureComponent} from 'react'
import {connect} from "react-redux";
import {modalShow} from "../../actions/ModalActions";

class ModalButton extends PureComponent {

    handleClick = () => {
        const {id, modalShow, data} = this.props;
        modalShow(id, data);
    };

    render() {
        const {className, children} = this.props;

        return <a onClick={this.handleClick} className={className}>{children}</a>;
    }
}

export default connect(
    state => ({
        modals: state.modal.modals,
    }),
    dispatch => ({
        modalShow: (name, data) => dispatch(modalShow(name, data)),
    })
)(ModalButton)